<template>
  <transition name="fade">
    <div v-show="visibility" class="dialog">
      <div class="dialog_content">
        <h5 v-show="title" class="title">{{ $t(title) }}</h5>
        <p class="hint">{{ $t(content) || $t('base_no_content') }}</p>
        <div class="operate">
          <div class="btn" :class="showCancel ? 'half-confirm' : 'confirm'" @click="confirm">
            {{ $t(confirmText) }}
          </div>
          <div v-show="showCancel" class="cancel btn" @click="cancel">
            {{ $t(cancelText) }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts" setup>
/**
 * 全局确认弹窗
 * props
 * @param {string} title // 标题
 * @param {string} content // 内容
 * @param {string} confirmText // 确认按钮i18n关键字
 * @param {string} cancelText // 取消按钮i18n关键字
 * @param {boolean} showCancel // 是否显示取消按钮(默认不显示)
 *
 * emit
 * @param {function} confirmEvent // 确认按钮绑定方法
 * @param {function} cancelEvent // 取消按钮绑定方法
 *
 * 使用$refs调用时，可以断言为HTMLFormElement
 */
defineProps({
  title: {
    type: String as PropType<string>,
    default: '',
  },
  content: {
    type: String as PropType<string>,
    default: '',
  },
  confirmText: {
    type: String as PropType<string>,
    default: 'base_confirm',
  },
  cancelText: {
    type: String as PropType<string>,
    default: 'base_cancel',
  },
  showCancel: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
})

const emit = defineEmits(['confirmEvent', 'cancelEvent'])
const visibility = ref(false)

// 显示
function show() {
  visibility.value = true
}

// 关闭
function close() {
  visibility.value = false
}

// 确认
function confirm() {
  emit('confirmEvent')
}

// 取消
function cancel() {
  close()
  emit('cancelEvent')
}

defineExpose({
  show,
  close,
})
</script>
<style lang="less" scoped>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);

  .dialog_content {
    width: 275px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 4px;

    .title {
      padding: 24px 20px 12px;
      font-size: 18px;
      color: @Text50;
      text-align: center;
    }

    .hint {
      max-height: 450px;
      overflow-y: auto;
      padding: 0 20px 25px;
      color: @Text50;
      font-size: 18px;
      text-align: center;
    }

    .operate {
      height: 50px;
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        height: 50px;
        border-top: solid 1px @Line50;
      }

      .cancel {
        width: 100%;
        color: @Text20;
        float: left;
      }
      .confirm {
        width: 100%;
        color: @Black50;
        font-weight: 500;
      }
      .half-confirm {
        width: 100%;
        float: right;
        color: @Black50;
        font-weight: 500;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
